










import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';

import JobWorkerInterviewStatus from '@/models/JobWorkerInterviews/JobWorkerInterviewStatus';


@Component({
  name: 'JobWorkerInterviewStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: JobWorkerInterviewStatus;

	get pendingConfirmation() {
		return this.hasStatus(JobWorkerInterviewStatus.PendingConfirmation);
	}

	get partiallyConfirmed() {
		return this.hasStatus(JobWorkerInterviewStatus.PartiallyConfirmed);
	}

	get fullyConfirmed() {
		return this.hasStatus(JobWorkerInterviewStatus.FullyConfirmed);
	}

	get cancelled() {
		return this.hasStatus(JobWorkerInterviewStatus.Cancelled);
	}

	get completed() {
		return this.hasStatus(JobWorkerInterviewStatus.Completed);
	}

	hasStatus(status: JobWorkerInterviewStatus) {
		if (this.status === status) {
			return true
		}
		return false;
	}
}
